import { createSelectionListViewComponent } from 'factories/SelectionListView'
import { getSessionItem, updateSessionItem } from 'helpers/sessionStorage'
import { getStorageKey } from '.'
import { AUTH_SESSION_KEY } from 'options/auth'

export default createSelectionListViewComponent({
  pageTitle: () => getSessionItem(AUTH_SESSION_KEY).current.customer.tagSettings.tag1,
  getItemSize: () => 45,
  allowSearch: () => true,
  getIdField: () => 'displayName',
  getValue: () => getSessionItem(getStorageKey(), {}).item?.jobDisplayName || '',
  getOnChange: (self) => (each) =>
    updateSessionItem(getStorageKey(), {}, (draft) => {
      draft.item.jobId = each.id
      draft.item.jobName = each.name || '*'
      draft.item.jobNumber = each.number
      draft.item.jobBarcode = each.barcode
      draft.item.jobDisplayName = each.displayName
    }),
})()
